export default "__VITE_ASSET__DnQ4VdmF__"